/**
 * @generated SignedSource<<0148bdb56b0db5c3a8b530433feafd07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleSectionHeader_teamSchedule$data = {
  readonly label: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule">;
  readonly " $fragmentType": "TeamScheduleSectionHeader_teamSchedule";
};
export type TeamScheduleSectionHeader_teamSchedule$key = {
  readonly " $data"?: TeamScheduleSectionHeader_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeader_teamSchedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleSectionHeader_teamSchedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleSectionHeaderSummary_teamSchedule"
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};

(node as any).hash = "817d09ddc0fbc5d0c23f202658f3c838";

export default node;
